import React from 'react';
import {Table} from '@/web-components';
import {hasFeatureFlag} from '../../../shared/util/FeatureUtil';

export const getBaseLevelTableHeaderTotals = (tableHeader, customFieldColumnCount) => {
	const columns = [
		<Table.Column></Table.Column>,
		<Table.Column></Table.Column>,
		<Table.Column></Table.Column>,
		...(hasFeatureFlag('deliverables') ? [<Table.Column></Table.Column>] : []),
		<Table.Column></Table.Column>,
		<Table.Column>{tableHeader.wholeTableReportedTime}</Table.Column>,
		<Table.Column>{tableHeader.wholeTableBillableRegistered}</Table.Column>,
		<Table.Column>{tableHeader.wholeTableNonBillableRegistered}</Table.Column>,
		<Table.Column></Table.Column>,
		<Table.Column></Table.Column>,
		<Table.Column></Table.Column>,
		<Table.Column></Table.Column>,
		<Table.Column></Table.Column>,
		<Table.Column></Table.Column>,
		<Table.Column></Table.Column>,
		<Table.Column>{tableHeader.wholeTableTotalPrice}</Table.Column>,
		<Table.Column>{tableHeader.wholeTableTotalCost}</Table.Column>,
		<Table.Column></Table.Column>,
		<Table.Column></Table.Column>,
		...new Array(customFieldColumnCount).fill(<Table.Column></Table.Column>),
	];

	const emptyRow = new Array(columns.length);

	return (
		<Table.Rows data={{rows: [emptyRow]}} canExpand={false} hasHeader>
			{({tableColumnsProps}) => {
				return <Table.Row {...tableColumnsProps}>{columns}</Table.Row>;
			}}
		</Table.Rows>
	);
};
